const MEASUREMENT_ID = process.env.VUE_APP_GA_MEASUREMENT_ID;
const META_PIXEL_ID = process.env.VUE_APP_META_PIXEL_ID;
let isGAInitialized = false;
let isMetaPixelInitialized = false;

const initGoogleAnalytics = () => {
  if (isGAInitialized || !MEASUREMENT_ID || typeof window === 'undefined') {
    return;
  }

  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  script.async = true;

  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line
    function gtag(){dataLayer.push(arguments);}
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', MEASUREMENT_ID);

    isGAInitialized = true;
    console.log('Google Analytics initialized.');
  };

  document.head.appendChild(script);
};

const initMetaPixel = () => {
  if (isMetaPixelInitialized || !META_PIXEL_ID || typeof window === 'undefined') {
    return;
  }

  // Meta Pixel initialization code
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  
  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');

  isMetaPixelInitialized = true;
  console.log('Meta Pixel initialized.');
};

export const initAnalytics = () => {
  if (typeof window === 'undefined') return;

  // Initialize Google Analytics
  if (MEASUREMENT_ID) {
    initGoogleAnalytics();
  } else {
    console.log('Google Analytics Measurement ID not found. GA disabled.');
  }

  // Initialize Meta Pixel
  if (META_PIXEL_ID) {
    initMetaPixel();
  } else {
    console.log('Meta Pixel ID not found. Meta Pixel disabled.');
  }
};

export const trackEvent = (eventName, eventParams = {}) => {
  // Track in Google Analytics
  if (isGAInitialized && typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams);
  }

  // Track in Meta Pixel
  if (isMetaPixelInitialized && typeof window.fbq === 'function') {
    // Map our custom events to Meta Pixel standard events when possible
    const metaEventMapping = {
      'inicio_carga_vehiculo': 'InitiateCheckout',
      'subida_producto': 'CompleteRegistration',
      'inicio_pago_senia': 'InitiateCheckout',
      'pago_senia_exitoso': 'Purchase'
    };

    const metaEventName = metaEventMapping[eventName] || 'CustomEvent';
    
    if (metaEventName === 'CustomEvent') {
      // For custom events, use trackCustom
      window.fbq('trackCustom', eventName, eventParams);
    } else {
      // For standard events, use track
      window.fbq('track', metaEventName, eventParams);
    }
  }
};

export const trackPageView = (pagePath, pageTitle) => {
  // Track page view in Google Analytics
  if (isGAInitialized && typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_title: pageTitle,
    });
  }

  // Track page view in Meta Pixel (already tracked automatically on init, but we can track custom page views)
  if (isMetaPixelInitialized && typeof window.fbq === 'function') {
    window.fbq('track', 'PageView');
  }
};

export const setUser = (userId) => {
  // Set user in Google Analytics
  if (isGAInitialized && typeof window.gtag === 'function') {
    window.gtag('config', MEASUREMENT_ID, {
      'user_id': userId
    });
  }

  // Set user in Meta Pixel (using external_id for user matching)
  if (isMetaPixelInitialized && typeof window.fbq === 'function') {
    window.fbq('init', META_PIXEL_ID, {
      external_id: userId
    });
  }
};
